'use client'

import { ReactNode } from 'react'
import { Button, Cell, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { PRIVACY_POLICY_URL } from '../../../../../../constants/routes'

type Props = {
  isLoading: boolean
}

const FormSubmit = ({ isLoading }: Props) => {
  const translate = useTranslate('advertising.form.submit')

  const disclaimerValues = {
    'policy-link': (chunks: Array<ReactNode>) => (
      <a key="policy-link" href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer">
        {chunks}
      </a>
    ),
  }

  return (
    <>
      <Spacer size="x-large" />
      <div className="u-phones-only">
        <Text text={translate('disclaimer', disclaimerValues)} type="caption" as="p" />
        <Spacer size="x2-large" />
        <Button
          type="submit"
          styling="filled"
          disabled={isLoading}
          isLoading={isLoading}
          onClick={(event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
            if (isLoading) {
              event.preventDefault()
            }
          }}
        >
          {translate('action')}
        </Button>
      </div>
      <div className="u-tablets-up-only">
        <Cell
          styling="tight"
          body={<Text text={translate('disclaimer', disclaimerValues)} type="caption" as="p" />}
          suffix={
            <Button
              type="submit"
              styling="filled"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={(event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
                if (isLoading) {
                  event.preventDefault()
                }
              }}
            >
              {translate('action')}
            </Button>
          }
        />
      </div>
    </>
  )
}

export default FormSubmit
